<template>
  <div class="product-category-list">

    <div v-if="productCategory.productCategories.length === 0" class="prodCatEmpty">
      <br/>
      <figure class="about-img2 img-wrapper">
        <img src="../assets/static/images/illustrations/category.svg" />
      </figure>
      <!-- <router-link :to="'/' + 'productCategories/create/' + $i18n.locale"><p> -->
      <button class="add-btn" @click="allowToAdd">{{ $t('addCategory') }}</button>
      <!-- </p> </router-link>               -->
    </div>

    <div v-else class="prodCatEntered">
      <PulseIcon v-on:click.native="allowToAdd();" />

      <transition-group
        class="product-category-cards"
        name="slide-up"
        tag="ul"
        appear>

        <ProductCategoryCard
          v-for="productCategory in productCategory.productCategories"
          :key="productCategory.id"
          :productCategory="productCategory"
          class="card-columns"/>
      </transition-group>
    </div>
    
  </div>
</template>

<script>
import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'
import PulseIcon from '@/components/common/PulseIcon.vue'
import { mapState } from 'vuex'

export default {
  components: {
    ProductCategoryCard,
    PulseIcon
  },
  created() {
    this.$store.dispatch('productCategory/fetchProductCategories')
  },
  methods: {
    allowToAdd() {
      this.$store.dispatch('client/profileCompleteness').then(response => {
        if (response && response.profile_complete === true)  {
            this.$router.push({
                path: '/productCategories/create/en'
            })
        } else {
          alert(this.$t('completeProfileFirst'))
        }
      })
    }
  },
  computed: mapState(['productCategory', 'client'])
}
</script>

<style lang="scss" scoped>

.prodCatEmpty {
  // display: none; //! none when NO prod.category with this client_id is found in db //
}
.prodCatEntered {
  // display: none; //! none when NO prod.category with this client_id is found in db //
}

.add-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  border-radius: 5px;
  letter-spacing: 3px;
  width: 30%;
}
.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}

.product-category-list {
  margin-top: 70px;
}
.product-category-cards {
  margin-top: 20px;
}

@media screen and (max-width: 780px){
  .add-btn {
  width: 80%;
}
}
</style>
